import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
  HttpResponse,
  HttpErrorResponse,
  HttpParams
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
  providedIn: 'root'
})

export class TokenInterceptor implements HttpInterceptor {
  currentLanguage:string="";

  constructor(
    private router: Router,
    private messageService: MessageService,
    private translateService: TranslateService,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let currentUser = JSON.parse(localStorage.getItem('AlghanimCurrentUser'));
    let authReq = null;
    this.currentLanguage= this.translateService.currentLang;
// Calculate timezone offset
const offset = new Date().getTimezoneOffset()*-1;
    if (currentUser && currentUser.data.token) {
     

      if (req.url.includes("UploadImportFiles") || req.url.includes("ImportServices") || req.url.includes("FilesUpload")) {
        authReq = req.clone(
         
          {             
            headers: new HttpHeaders(
              {
                'Authorization': "bearer " + currentUser.data.token,
                 //'Content-Type': 'application/x-www-form-urlencoded',
                'Access-Control-Allow-Origin': '*',
                'LanguageId': '' + (currentUser.data.languageId || 1),   
                'Timezone-Offset': offset.toString() // Add timezone offset header
                          
              }
            ),
           
           params:new HttpParams().set(
              "culture",this.currentLanguage
            ),
          }
        );
      }
      else {
        authReq = req.clone(
          {
            params:new HttpParams().set(
              "culture",this.currentLanguage
            ),

            headers: new HttpHeaders(
              {
                'Authorization': "bearer " + currentUser.data.token,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'LanguageId': '' + (currentUser.data.languageId || 1),
                'Timezone-Offset': offset.toString() // Add timezone offset header
              }
            )
          }
        );
      }

    } else {
      authReq = req.clone(
        {
          params:new HttpParams().set(
            "culture",this.currentLanguage
          ),
          headers: new HttpHeaders(
            {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Timezone-Offset': offset.toString() // Add timezone offset header
            }
          )
        }
      );
    }

    return next.handle(authReq).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
        }
      }, (err: any) => {
        console.error("Inerceort Error ", err);
        if (err instanceof HttpErrorResponse) {


          if (err.error && err.error.Status && err.error.Status.Message) {
            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('Failed'),
              detail: this.translateService.instant(err.error.Status.Message || `Please Login again.`)
            })
          }

          if (err.status == 403) {
            //
            console.error(err);
            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('Failed'),
              detail: this.translateService.instant(err.error.Status.Message || err.error.Status.Message)
            })
            localStorage.clear();
            this.router.navigate(['/login']);
          }

          if (err.status == 402) {
            debugger;
            //
            console.error(err);
            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant(err.statusText || err.statusText),
              detail: this.translateService.instant(err.error || err.error)
            })
            localStorage.clear();
            this.router.navigate(['/login']);
          }

          if (err.status == 401) {
            localStorage.clear();
            this.router.navigate(['/login']);
            console.error(err);
          }
        }
      })
    );

  }
}

// import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
// import { Observable } from 'rxjs';
// import { Injectable } from '@angular/core';
// import { tap } from 'rxjs/operators';
// import { Router } from '@angular/router';

// @Injectable()
// export class TokenInterceptor implements HttpInterceptor {

//     constructor(
//         private router: Router
//     ) { }

//     intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//         let copiedReq = null;
//         let currentUser = JSON.parse(localStorage.getItem('AlghanimCurrentUser'));
//         if (currentUser && currentUser.data.token) {
//             copiedReq = req.clone({
//                 setHeaders: {
//                     'Authorization': `Bearer ${currentUser.data.token}`,
//                     'Content-Type': 'application/json',
//                     'Access-Control-Allow-Origin': '*'
//                 }
//             });
//         } else {
//             copiedReq = req.clone({
//                 setHeaders: {
//                     'Content-Type': 'application/json',
//                     'Access-Control-Allow-Origin': '*'
//                 }
//             });
//         }
//         console.log(copiedReq);
//         return next.handle(copiedReq).pipe(
//             tap((ev: HttpEvent<any>) => { console.log(ev) },
//                 error => {
//                     if (error.status == '401' || error.status == '402' || error.status == '403') {
//                         localStorage.clear();
//                         this.router.navigate(['/login']);
//                         console.error(error);
//                     }
//                 }
//             ));
//     }
// }

